import { CommonModule } from '@angular/common';
import { AfterContentInit, ChangeDetectionStrategy, Component, ElementRef, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { SortingModel } from 'src/business/services/client.generated';
import { CatalogContentAndSearchResolver } from 'src/core-lib/navigation/services/content.resolver';

@Component({
    selector: 'app-catalog-sort',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './catalog-sort.component.html',
    styleUrls: [
        '../../styles/facet-sort.scss',
        './catalog-sort.component.scss'
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class CatalogSortComponent implements AfterContentInit {
    _sortings: SortingModel[];
    @Input() set sortings(sortings: SortingModel[]) {
        this._sortings = sortings;
    }
    constructor(
        private _elm: ElementRef<HTMLElement>,
        private _productSearchService: CatalogContentAndSearchResolver,
    ) {}
    ngAfterContentInit(): void {
        queueMicrotask(() => this.recalcMaxWidth())
    }
    recalcMaxWidth(): void {
        // if (window.matchMedia('(min-width: 1280px)').matches)
        //     this._elm.nativeElement
        //         .querySelectorAll('details')
        //         .forEach(detailsElm => {
        //             detailsElm.style.maxWidth = detailsElm.querySelector('summary').clientWidth + 'px';
        //         })
    }
    updateUrl() {
        this._productSearchService.updateUrlByForm(new FormData(window['catalogForm']));
    }
}
